module.exports = __webpack_public_path__ + "img/neogeo_logo.6d33b0e6.png";